import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
    {
        path: 'login',
        loadComponent: () => import('./login/login.component').then((m) => m.LoginComponent),
    },
    {
        path: 'inscription',
        loadComponent: () => import('./register/containers/register.component').then((m) => m.RegisterComponent),
    },
    {
        path: 'password-recover/:token',
        loadComponent: () => import('./password-recover/containers/password-recover.component').then((m) => m.PasswordRecoverComponent),
    },
    {
        path: 'inscription-collaborateur',
        loadComponent: () =>
            import('./inscription-collabo/containers/inscription-collabo/inscription-collabo.component').then((m) => m.InscriptionCollaboComponent),
    },
];
